// MobileIntradayDollarInfoPage.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Button, Radio, RadioGroup } from '@blueprintjs/core'; 
import IntradayRecordsTable from '../components/tables/IntradayRecordsTable';
import FirstLeftTable from '../components/tables/FirstLeftTable';
import SecondLeftTable from '../components/tables/SecondLeftTable';
import CandleStickChart from '../components/charts/CandleStickChart';
import AlertasModal from '../components/modales/AlertasModal';
import * as con from "./../GlobalConstants";
import { RefRole, RefToken } from '../components/hooks/AuthenticationHook';
import { RefUserAttributesHook } from '../components/hooks/UserAttributesHook';
import { getFinanceRequestConfig } from "../store/logic/supportFunctions";
import { RefAlertsHook } from '../components/hooks/TransactionsHooks';

const config = getFinanceRequestConfig();

function MobileIntradayDollarInfoPage() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [selectedPage, setSelectedPage] = useState('resumen'); 
    const [isModalOpen, setIsModalOpen] = useState(false);

    const user = RefUserAttributesHook('user');
    const token = RefToken();
    const role = RefRole;
    const alerts = RefAlertsHook();

    const handleOpenModal = () => setIsModalOpen(true);
    const handleCloseModal = () => setIsModalOpen(false);

    const fetchIntradayData = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${con.rest_finance_url}${con.intraday_dollar_info}`, config);
            setData(response.data);
        } catch (error) {
            console.error('Error fetching data:', error);
            setData(null);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchIntradayData();
    }, []);

    if (loading) {
        return <div>Cargando...</div>;
    }

    if (!data) {
        return <div>No se pudo cargar la información intradía del dólar.</div>;
    }

    const isMarketClosed = data.market_status === 'closed';
    const isNotViewer = role !== con.VIEWER;

    return (
        <div style={{ padding: '10px', width: '100%' }}>

            {isMarketClosed && (
                <div style={{ 
                    position: 'relative', 
                    top: '10px', 
                    backgroundColor: 'rgba(255, 0, 0, 0.8)',
                    color: 'white',
                    padding: '5px',
                    fontSize: '14px',
                    textAlign: 'center',
                    borderRadius: '5px',
                    marginBottom: '20px'
                }}>
                    El mercado está cerrado
                </div>
            )}

            <div style={{ display: 'flex', justifyContent: 'space-around', marginBottom: '10px' }}>
                <Button 
                    text="Actualizar" 
                    onClick={fetchIntradayData} 
                    style={{ fontSize: '14px', padding: '8px 16px' }}
                />
                {isNotViewer && (
                    <Button 
                        text="Alertas" 
                        icon="notifications" 
                        onClick={handleOpenModal} 
                        disabled={!user || !token}
                        style={{ fontSize: '14px', padding: '8px 16px' }}
                    />
                )}
            </div>

            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px' }}>
                <RadioGroup
                    selectedValue={selectedPage} 
                    onChange={(e) => setSelectedPage(e.currentTarget.value)}
                    style={{ fontSize: '12px', flexDirection: 'column', alignItems: 'center' }}
                >
                    <Radio value="resumen" label="Resumen del dólar actual" />
                    <Radio value="cotizaciones" label="Cotizaciones intraday" />
                </RadioGroup>
            </div>

            {selectedPage === 'resumen' && (
                <div>
                    <FirstLeftTable data={data} />
                    <SecondLeftTable data={data} />
                    <CandleStickChart data={data.intraday_data} alerts={alerts} />
                </div>
            )}  

            {selectedPage === 'cotizaciones' && (
                <div>
                    {data.intraday_data ? (
                        <IntradayRecordsTable data={data.intraday_data} />
                    ) : (
                        <div>No hay datos intradía disponibles.</div>
                    )}
                </div>
            )}

            <AlertasModal
                isOpen={isModalOpen}
                handleClose={handleCloseModal}
                isMobile={true}
            />
        </div>
    );
}

export default MobileIntradayDollarInfoPage;